/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';
import { SalesQuotePriceListsBatchCreateDto } from '../../models/sales-quote-price-lists-batch-create-dto';

export interface QuotePriceListsControllerBatchCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The quote ID to add price lists to.
 */
  quoteId: string;
      body: SalesQuotePriceListsBatchCreateDto
}

export function quotePriceListsControllerBatchCreate(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerBatchCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerBatchCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('quoteId', params.quoteId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>;
    })
  );
}

quotePriceListsControllerBatchCreate.PATH = '/o2-sales/quote-price-lists/{tenant}/batch/{quoteId}';
